<template>
  <div class="wechat-pannel page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <el-tabs
        v-model="activeName"
      >
        <el-tab-pane
          label="好友列表"
          name="friend"
        >
          <div class="con-tab-ejemplo">
            <friend-list
              ref="friend"
              :bot-id="selfBotId"
              :active-name="activeName"
            ></friend-list>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="群聊列表"
          name="chat"
        >
          <div class="con-tab-ejemplo">
            <room-chat
              ref="chat"
              :bot-id="selfBotId"
              :active-name="activeName"
            ></room-chat>
          </div>
        </el-tab-pane>
        <el-tab-pane
          name="usertag"
          label="用户标签"
        >
          <div class="con-tab-ejemplo">
            <user-tag
              ref="tag"
              :bot-id="selfBotId"
              :active-name="activeName"
            ></user-tag>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import userTag from "@/components/wechat/wechat-panel/userTag";
import roomChat from "@/components/wechat/wechat-panel/roomChat";
import friendList from "@/components/wechat/wechat-panel/friendList";
import queryHeader from "@/components/wechat/wechat-panel/queryHeader";
export default {
  name: "wechat-pannel",
  components: {
    queryHeader,
    friendList,
    roomChat,
    userTag,
  },
  data() {
    return {
      activeName: 'friend',
      selfBotId: 0,
    }
  },
  watch:{
  },
  methods: {
    toQuery(botId){
      this.selfBotId = botId;
    }
  },
}
</script>

<style lang="scss" scoped>
.wechat-pannel {
  .con-tab-ejemplo {
  }
  .page-content {
    padding: 20px;
  }
}
@media screen and (min-width: 768px){
  .page-box {
    position: relative;
  }
}
</style>
